export default __webpack_public_path__ + "static/media/quantum.6eeabe5c.svg";